import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { toast } from "sonner";
import { Download, Copy, ExternalLink, RefreshCw } from "lucide-react";
import Layout from "../components/Layout";
import { Button } from "../components/ui/button";
import { API } from "../lib/api";

const DOC_URL = `${API}/hermes/docs.md`;

export default function HermesApiDocs() {
  const [md, setMd] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    fetch(DOC_URL)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((t) => setMd(t))
      .catch(() => toast.error("Gagal memuat dokumentasi"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const copyLink = () => {
    navigator.clipboard.writeText(DOC_URL);
    toast.success("Link dokumentasi disalin");
  };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-6" data-testid="hermes-docs-page">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Hermes API Docs</h1>
            <p className="text-sm text-slate-500">Dokumentasi read-only API untuk Hermes Agent. Bagikan link atau unduh file .md.</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" size="sm" onClick={load} data-testid="hermes-docs-refresh">
              <RefreshCw className="w-4 h-4 mr-1.5" /> Muat ulang
            </Button>
            <Button variant="outline" size="sm" onClick={copyLink} data-testid="hermes-docs-copy-link">
              <Copy className="w-4 h-4 mr-1.5" /> Salin link
            </Button>
            <Button variant="outline" size="sm" asChild data-testid="hermes-docs-open-raw">
              <a href={DOC_URL} target="_blank" rel="noreferrer">
                <ExternalLink className="w-4 h-4 mr-1.5" /> Buka .md
              </a>
            </Button>
            <Button size="sm" asChild data-testid="hermes-docs-download">
              <a href={`${DOC_URL}?download=1`}>
                <Download className="w-4 h-4 mr-1.5" /> Unduh .md
              </a>
            </Button>
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          {loading ? (
            <p className="text-sm text-slate-400">Memuat…</p>
          ) : (
            <article className="hermes-md prose prose-slate max-w-none prose-sm md:prose-base prose-pre:bg-slate-900 prose-pre:text-slate-100 prose-table:text-sm prose-headings:scroll-mt-20">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
            </article>
          )}
        </div>
      </div>
    </Layout>
  );
}
